module.exports = __webpack_public_path__ + "img/84.2f83dbcd.jpg";